/**
 * POST /api/v1/projects — `clientType` values (backend contract; strings must match exactly).
 * @see docs/projects.docs.md
 */
export const PROJECT_CLIENT_TYPE = {
    MINE_AND_PLATFORM: 'mine and platform client',
    PLATFORM: 'platform client',
    OUT_OF_PLATFORM: 'out of the platform',
    OWN_PRODUCT: 'own product',
};
